import { mockFileStructure, buildMockRevisions, mockSourceXml, mockTargetXml } from './mockData.js';

const MOCK = import.meta.env?.VITE_MOCK === 'true';

function mockResolve(url, success) {
  // Match the URL shapes built by mapper.js dvsRestPoint().
  if (/\/dvs\/rest\/configs\/[^/]+\/$/.test(url)) {
    success(mockFileStructure);
    return;
  }
  if (/\/dvs\/rest\/configs\/[^/]+\/[^/]+\/[^/]+\/log/.test(url)) {
    success(buildMockRevisions(120));
    return;
  }
  const revMatch = url.match(/\/revision\/(\d+)/);
  if (revMatch) {
    // Alternate by rev parity so source and target XML differ — DiffView
    // gets real red/green chunks to render.
    const rev = parseInt(revMatch[1], 10);
    success(rev % 2 === 0 ? mockSourceXml : mockTargetXml);
    return;
  }
  success(null);
}

export function fetcher(loading, error, success, url, parser) {
  loading(true);

  if (MOCK) {
    setTimeout(() => {
      try {
        mockResolve(url, success);
        loading(false);
      } catch (e) {
        console.error('mock fetcher error', e);
        error(true);
      }
    }, 50);
    return;
  }

  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      loading(false);
      return response;
    })
    .then((response) => response.text())
    .then((result) => parser(result, success))
    .catch(() => error(true));
}
